import React, { useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import noimage from "../../assets/img/noimage.png";
import { useLocation, useNavigate } from "react-router-dom";
import { isEmpty } from "../../Actions/common";
import { socialAdd, socialEdit } from "../../Actions/axios";
import { toast } from "react-toastify";
import config from '../../config/config';

const SocialEdit = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [data, setData] = useState({});
  const [err, setErr] = useState({});

  const onChangeFunc = (e) => {
    const { name, value, files } = e.target;
    setData({ ...data, [name]: files ? files[0] : value });
  };

  const validataion = async () => {
    let err = {};
    if (isEmpty(data?.title)) {
      err.title = "Title Required";
    }
    if (isEmpty(data?.link)) {
      err.link = "Link Required";
    }
    if (!data?.image && isEmpty(data?.image?.name)) {
      err.logo = "Logo Required";
    }
    setErr(err);
    return err;
  };

  const editSocial = async () => {
    let err = await validataion();
    if (!isEmpty(err)) {
      toast.error("Field Required");
    }
    let resp = await socialEdit(data);
    console.log("🚀 ~ saveSocial ~ resp:", resp);
    if (resp?.status) {
      toast.success(resp?.message);
      navigate("/sociallist");
    } else {
      toast.error(resp?.message);
    }
  };

  useEffect(() => {
    setData(location?.state);
  }, [location]);

  return (
    <div className="cmsadd">
      <button className="btn sitebtn mb-4" onClick={() => navigate(-1)}>
        Back
      </button>
      <h1 className="pagehead">Social Link Edit</h1>
      <div className="cardbox">
        <Form>
          <Row>
            <Col xs={12} sm={12} md={6} lg={6} className="mb-4">
              <Form.Group>
                <Form.Label>Title</Form.Label>
                <Form.Control
                  type="text"
                  name="title"
                  value={data?.title}
                  onChange={onChangeFunc}
                />
                {err?.title && <p>{err?.title}</p>}
              </Form.Group>
            </Col>
            <Col xs={12} sm={12} md={6} lg={6} className="mb-4">
              <Form.Group>
                <Form.Label>Link</Form.Label>
                <Form.Control
                  type="text"
                  name="link"
                  value={data?.link}
                  onChange={onChangeFunc}
                />
                {err?.link && <p>{err?.link}</p>}
              </Form.Group>
            </Col>

            <Col xs={12} sm={6} className="mb-4">
              <Form.Group>
                <Form.Label>Logo</Form.Label>
                <div className="uploadimgbox">
                  <img
                    src={data?.image ? URL.createObjectURL(data?.image) : `${config.Back_URL}social/${data.logo}`}
                    alt="user"
                    className="img-fluid"
                  />
                  <Form.Control
                    type="file"
                    name="image"
                    onChange={onChangeFunc}
                  />
                </div>
                {err?.logo && <p>{err?.logo}</p>}
              </Form.Group>
            </Col>
          </Row>
        </Form>
        <button
          type="button"
          onClick={() => editSocial()}
          className="btn sitebtn py-2 px-3"
        >
          Edit
        </button>
      </div>
    </div>
  );
};

export default SocialEdit;
